import React from 'react'
import {Col} from "reactstrap";
import {
    categoryAlias, categoryAliasId,categoryNameUrlAlias,
    typeAlias, typeAliasId, typesForSelect,
} from "../../helpers/utils";
import Select from "react-select";
import InputFactory from "../../components/Estate/InputFactory";
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/navigation'

const SearchParametersComponent = ({
                                       selectedLang,
                                       formData,
                                       setFormData,
                                       handleSearchSubmit,
                                       showTitle,
                                       initialData,
                                       searchPageParameters
}: {
    selectedLang: any,
    formData: any,
    setFormData: any,
    handleSearchSubmit: any,
    showTitle: any,
    initialData: any,
    searchPageParameters: any
}) => {
    const t = useTranslations('')
    const router = useRouter()

    const types = typesForSelect.map((option: any) => ({
        ...option,
        label: t(option.label), // Translate label
    }));
    const handleChange = (e: any) => {
        let {id, value} = e.target;

        setFormData((prevFormData: any) => ({
            ...prevFormData,
            [id]: value,
        }));
    }

    const handleMultiSelectChange = (name: string, selectedOptions: any) => {
        if (name === 'regions') {
            const result = selectedOptions.map((item: any) => {
                return item.value.toString();
            })
            setFormData({
                ...formData,
                [name]: result,
            });
        } else {
            const params = formData.parameters
            let currentFlatParams = formData.parametersFlat;

            params[name] = selectedOptions.map((region: any) => region.value);
            currentFlatParams[name] = selectedOptions.map((region: any) => region.value);

            setFormData({
                ...formData,
                parameters: params,
                parametersFlat: currentFlatParams,
            });
        }
    };

    const handleRoomSelectChange = (name: string, selectedOptions: any) => {
        const currentParams = formData.parameters;
        const currentFlatParams = formData.parametersFlat;

        const result = selectedOptions.map((item: any) => {
            return item.value.toString();
        })

        currentParams[name] = result
        currentFlatParams["11-min"] = Math.min(...result);

        setFormData({
            ...formData,
            parameters: currentParams,
            parametersFlat: currentFlatParams,
        });
    }

    const handleSelectChange = (name: string, parameter = false) => (e: any) => {
        setFormData((prevFormData: any) => {
            if (parameter) {
                return {
                    ...prevFormData,
                    parameters: {
                        ...prevFormData.parameters,
                        [name]: e.value,
                    },
                };
            } else {
                let value = e.value;
                if (name === 'category') {
                    value = categoryAlias[value];
                } else if (name === 'type') {
                    value = typeAlias[value];
                }

                return {
                    ...prevFormData,
                    [name]: value,
                };
            }
        });
    };

    const handleSearchInputChange = (e: any) => {
        const {id, value} = e.target;

        let currentParams = formData.parameters;
        let currentFlatParams = formData.parametersFlat;
        currentFlatParams[id] = value;

        if (id.includes("min")) {
            const baseId = id.replace(/-min/g, '');
            if (!currentParams[baseId]) {
                currentParams[baseId] = {};
            }

            if (value) {
                currentParams[baseId].min = value;
            } else {
                delete currentParams[baseId]['min'];
            }
        } else if (id.includes("max")) {
            const baseId = id.replace(/-max/g, '');
            if (!currentParams[baseId]) {
                currentParams[baseId] = {};
            }

            if (value) {
                currentParams[baseId].max = value;
            } else {
                delete currentParams[baseId]['max'];
            }
        } else {
            currentParams[id] = value;
        }

        setFormData({
            ...formData,
            parameters: currentParams,
            parametersFlat: currentFlatParams,
        });
    };

    return (
        <div className="search-block-left">
            {showTitle && <h6 style={{marginBottom: '21px'}}>{t('Search by Filters')}</h6>}
            <form>
                <div className="form-group">
                    <label htmlFor="code" className="form-label">{t('Search by code')}</label>
                    <input
                        className="form-control"
                        type="text"
                        name="code"
                        id="code"
                        value={formData.code}
                        onChange={handleChange}
                        placeholder={t('Search by code')}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="code" className="form-label">{t('Category')}</label>
                    <Select
                        value={
                            initialData.categories.filter((option: any) => {
                                return categoryAliasId[formData.category] === option.value;
                            })
                        }
                        className="custom-select-box-design"
                        onChange={handleSelectChange('category', false)}
                        options={initialData.categories}
                        styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: '#e8e8e8',
                                fontSize: '14px',
                                color: '#212529',
                                borderRadius: '8px',
                            }),
                        }}
                    />
                </div>
                <div className="form-group">
                    <div className="mb-3">
                        <label htmlFor="code" className="form-label">{t('Type')}</label>
                        <Select
                            value={
                                types.filter((option: {value: string, label: string}) => {
                                    return typeAliasId[formData.type] === option.value;
                                })
                            }
                            className="custom-select-box-design"
                            onChange={handleSelectChange('type', false)}
                            options={types}
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: '#e8e8e8',
                                    fontSize: '14px',
                                    color: '#212529',
                                    borderRadius: '8px',
                                }),
                            }}
                        />
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="code" className="form-label">{t('Region')}</label>
                    <Select
                        isMulti
                        className="custom-select-box-design"
                        onChange={(selectedOptions) => handleMultiSelectChange('regions', selectedOptions)}
                        value={
                            initialData.regions.filter((option: {value: string, label: string}) => {
                                return formData.regions.includes(option.value.toString());
                            })
                        }
                        options={initialData.regions}
                        placeholder={t('Region')}
                        closeMenuOnSelect={false}
                        blurInputOnSelect={false}
                        styles={{
                            control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: '#e8e8e8',
                                fontSize: '14px',
                                color: '#212529',
                                borderRadius: '8px',
                            }),
                            multiValue: (styles, {data}) => {
                                return {
                                    ...styles,
                                    borderRadius: '12px',
                                    fontSize: '13px'
                                };
                            },

                            multiValueRemove: (styles, {data}) => ({
                                ...styles,
                                ':hover': {
                                    backgroundColor: 'inherit',
                                    borderRadius: '12px',
                                    color: 'white',
                                },
                            }),
                        }}
                    />
                </div>
                <div className="params-container mt-3">
                    {searchPageParameters?.map((parameter: any, index: number) => {
                        let handleInputChange = parameter.type === 'Selective' || parameter.type === 'Selective (Multiple)'
                            ? (selectedOptions: any) => handleMultiSelectChange(parameter.id, selectedOptions)
                            : (e: any) => handleSearchInputChange(e);


                        let value = formData.parameters[parameter.id]
                        const multiSelectParams = [8, 37];

                        if (multiSelectParams.includes(parameter.id)) {
                            value = formData.parameters[parameter.id]
                        }

                        if (parameter.id === 11) {
                            handleInputChange = (selectedOptions) => handleRoomSelectChange(parameter.id, selectedOptions)
                        }

                        return (
                            <Col md={12} key={index}>
                                <div className="mb-3">
                                    <InputFactory
                                        parameter={parameter}
                                        value={value}
                                        onChange={handleInputChange}
                                        isRange={true}
                                        verticalRange={false}
                                    />
                                </div>
                            </Col>
                        );
                    })}
                </div>
                <button id="globalSearch" className="btn search-btn filters-submit"
                        onClick={handleSearchSubmit}>{t('Search')}
                </button>
            </form>
        </div>
    );
};

export default SearchParametersComponent;
